import { format } from 'date-fns';
import { CalendarBlank, CalendarCheck, CreditCard, Repeat, Warning, CaretRight } from '@phosphor-icons/react';
import { formatCurrencyAmounts, parseDate } from './helpers';

export const WeekOverview = ({ week, upcoming }) => (
  <div className="lg:col-span-2 bg-white border border-[#f2f4f6] rounded-2xl p-6" data-testid="week-overview">
    <div className="flex items-center gap-2 mb-5">
      <CalendarCheck size={18} className="text-[#005bc1]" weight="duotone" />
      <span className="text-[#005bc1] text-xs font-bold uppercase tracking-widest">This Week</span>
    </div>

    <div className="space-y-3">
      <div className="flex items-center justify-between p-3 bg-[#fafbfc] rounded-xl">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#fee2e2] flex items-center justify-center">
            <CreditCard size={18} className="text-[#dc2626]" weight="duotone" />
          </div>
          <div>
            <p className="font-semibold text-sm text-[#2d3338]">{week.bills || 0} Bills</p>
            <p className="text-xs text-[#596065]">
              {week.bills_by_currency && Object.keys(week.bills_by_currency).length > 0
                ? formatCurrencyAmounts(week.bills_by_currency)?.join(' + ')
                : 'No bills due'}
            </p>
          </div>
        </div>
        <CaretRight size={14} className="text-[#acb3b8]" />
      </div>

      <div className="flex items-center justify-between p-3 bg-[#fafbfc] rounded-xl">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#dbeafe] flex items-center justify-center">
            <CalendarBlank size={18} className="text-[#1d4ed8]" weight="duotone" />
          </div>
          <div>
            <p className="font-semibold text-sm text-[#2d3338]">{week.appointments || 0} Appointments</p>
            <p className="text-xs text-[#596065]">Scheduled this week</p>
          </div>
        </div>
        <CaretRight size={14} className="text-[#acb3b8]" />
      </div>

      <div className="flex items-center justify-between p-3 bg-[#fafbfc] rounded-xl">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#ede9fe] flex items-center justify-center">
            <Repeat size={18} className="text-[#6d28d9]" weight="duotone" />
          </div>
          <div>
            <p className="font-semibold text-sm text-[#2d3338]">{week.subscriptions || 0} Subscriptions</p>
            <p className="text-xs text-[#596065]">Renewing this week</p>
          </div>
        </div>
        <CaretRight size={14} className="text-[#acb3b8]" />
      </div>

      {week.overdue > 0 && (
        <div className="flex items-center justify-between p-3 bg-[#fef2f2] rounded-xl border border-[#fecaca]">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-[#fecdd3] flex items-center justify-center">
              <Warning size={18} className="text-[#dc2626]" weight="fill" />
            </div>
            <div>
              <p className="font-semibold text-sm text-[#dc2626]">{week.overdue} Overdue</p>
              <p className="text-xs text-[#dc2626]/70">Needs immediate attention</p>
            </div>
          </div>
          <a href="/inbox" className="text-xs font-bold text-[#dc2626] hover:underline">View</a>
        </div>
      )}
    </div>

    {upcoming.length > 0 && (
      <div className="mt-5 pt-5 border-t border-[#f2f4f6]">
        <p className="text-xs text-[#596065] uppercase tracking-wider mb-3 font-bold">Due in 48 hours</p>
        <div className="space-y-2">
          {upcoming.slice(0, 3).map((t, i) => (
            <div key={i} className="flex items-center justify-between text-sm">
              <span className="text-[#2d3338] truncate flex-1 mr-2">{t.title}</span>
              <span className="text-xs text-[#596065] flex-shrink-0">
                {parseDate(t.due_date) ? format(parseDate(t.due_date), 'MMM d') : ''}
              </span>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);
